module.exports = __webpack_public_path__ + "4f5f21453e10de4199c2d6af983aa757.svg";